import React, { useEffect, useState, useMemo } from "react";
import { BreadcrumbComponent } from "../../../../common/components";
import { getLeads } from "../../../../api/lead";
import { PaginationComponent } from "../../../../common/components";
import { useSetLoading } from "../../../../common/hooks/appearance";
import TooltipIcon from "../../../../assets/icons/tooltip-icon.svg";
import "../lead-assignment.scss";
import LeadsListTable from "./leads-list-table";
import { AlertComponent } from "../../../../common/components";
import { Link } from "react-router-dom";
import { routes } from "../../../../constants/routes";
import LeadView from "../../lead-view/lead-view";
import { useNavigate } from "react-router-dom";

interface SortOption {
  sortDirection: string | null;
  sortBy: string | null;
}
const ApprovedLeads = () => {
  const defaultBreadcrumbLink = [
    { label: "Lead Assignment", link: routes.UNASSIGNEDLEADS },
    { label: "Unassigned Leads", link: routes.UNASSIGNEDLEADS },
    { label: "All Approved Leads", link: "#", handleClick: () => {} },
  ];
  const [crumbMappingOption, setCrumbMappingOption] = useState<any>(
    defaultBreadcrumbLink
  );
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [selectedLeadsMap, setSelectedLeadsMap] = useState<{
    [page: number]: number[];
  }>({});
  const isAllSelected = selectedLeadsMap[currentPage]?.length === data.length;
  const isIndeterminate =
    selectedLeadsMap[currentPage]?.length > 0 &&
    selectedLeadsMap[currentPage]?.length < data.length;
  const [loading, setLoading] = useState<boolean>(false);
  const [pageSize] = useState<number>(15);
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [sortOption, setSortOption] = useState<SortOption>({
    sortDirection: null,
    sortBy: null,
  });
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [selectedLeadId, setSelectedLeadId] = useState<any>(null);
  const [selectedLeadName, setSelectedLeadName] = useState<string>("");
  const navigate = useNavigate();

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };

  const fetchLeads = async (page = 1, search: string = "") => {
    setLoading(true);
    try {
      const offset = (page - 1) * pageSize;
      let params: any = {
        limit: pageSize,
        offset: offset,
        approvedLeadsList: true,
      };
      if (sortOption?.sortBy) {
        params = { ...params, ...sortOption };
      }
      if (search) {
        params.searchText = search;
      }
      const response = await getLeads(params);
      setData(response.data.data.leads);
      setTotalRecords(response.data.data.totalRecords);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while fetching the leads."
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    fetchLeads(currentPage);
  }, [currentPage, sortOption]);

  const handleViewClick = async (leadId: number, leadName: string) => {
    setSelectedLeadId(leadId);
    setSelectedLeadName(leadName);
    setCrumbMappingOption([
      { label: "Lead Assignment", link:routes.UNASSIGNEDLEADS, handleClick: () => {} },
      {
        label: "Unassigned Leads",
        link: routes.UNASSIGNEDLEADS,
        handleClick: (event: any) => {
          event.preventDefault();
          setViewOpen(false);
          navigate(routes.UNASSIGNEDLEADS)
        },
      },
        {
        label: "All Approved Leads",
        link: routes.APPROVEDLEADS,
        handleClick: (event: any) => {
          event.preventDefault();
          setCrumbMappingOption(crumbMappingOption);
          setViewOpen(false);
          setCurrentPage(1);
          fetchLeads();
        },
      },
      { label: leadName, link: "" },
    ]);
    setViewOpen(true);
  };

  const handleLeadNameUpdate = (newName: string) => {
    setSelectedLeadName(newName);
    setCrumbMappingOption((prev: any) => {
      const updated = [...prev];
      updated[3] = { ...updated[3], label: newName };
      return updated;
    });
  };

   const noResultsTxt = useMemo(() => {
      if (loading) {
       return "Loading Leads...";
     }
     return "No Leads found";
   }, [loading]);

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <>
      <div className="leadlist-wrapper approved-leads-wrapper">
        <div className="breadcrumb-wrapper">
          <BreadcrumbComponent breadcrumbLink={crumbMappingOption} />
        </div>
        <div style={{ display: !viewOpen ? "block" : "none" }}>
          <LeadsListTable
            fieldName="approved-leads-list"
            data={data}
            isAllSelected={isAllSelected}
            isIndeterminate={isIndeterminate}
            selectedLeadsMap={selectedLeadsMap}
            setSelectedLeadsMap={setSelectedLeadsMap}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSortOption={setSortOption}
            customClassName="approved-leads-table"
            selectedLeadsFilterOptions={[]}
            selectedLeadsFilter={[]}
            viewOpen={viewOpen}
            setViewOpen={setViewOpen}
            handleViewClick={handleViewClick}
            noResultsTxt={noResultsTxt}
          />
          {totalRecords && totalRecords > 0 ? (
            <div className="leads-pagination-container">
              <PaginationComponent
                totalRecords={totalRecords}
                pageSize={pageSize}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        {!viewOpen ? (
          ""
        ) : (
          <LeadView
            setLoading={setLoading}
            selectedLeadId={selectedLeadId}
            onLeadNameUpdate={handleLeadNameUpdate}
            disableLeadStatus={true}
          />
        )}
        <AlertComponent
          message={alertMessage}
          open={alertOpen}
          type={alertType}
          onClose={() => {
            setAlertOpen(false);
          }}
        />
      </div>
    </>
  );
};

export default ApprovedLeads;